/**
 * @module framework/directives
 */

import { App } from '~/framework/vue';

import { focus } from './focus';
import { progressive } from './progressive';
import { scrollTo } from './scroll-to';

export const directives = (app: App) => {
    focus(app);
    scrollTo(app);
    progressive(app);
};
